
import imModal from '../imModal'
import { copyToClip } from '~/utils/index'
export default {
    name: 'BuyerAddPrice',
    components: {
        imModal
    },
    props: {
        content: {
            type: Object,
            default: () => ({})
        },
        mentionedUser: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            btnLoading: false,
            accountIsShow: false,
            centerPayDialogVisible: false
        }
    },
    computed: {
        parData () {
            return {
                orderNo: this.content.modifyOrderNo,
                businessScene: 'CHANGE_PRICE',
                payChannel: this.content.payWay,
                payTotalMoney: this.content.differencePrice
            }
        },
        totalPrice () {
            const { newTransactionPrice, newCompensationFee, couponDiscount, newMerchantDeductionAmount } = this.content
            const merchantDeductionAmount = newMerchantDeductionAmount || 0
            return Number((+newTransactionPrice + +newCompensationFee - +couponDiscount - +merchantDeductionAmount).toFixed(2))
        }
    },
    methods: {
        copyToClip,
        // 线上支付
        async checkPay () {
            this.btnLoading = true
            try {
                // 检查是否可以支付
                const res = await this.$api.changePricePayConfirm({
                    modifyOrderNo: this.parData.orderNo
                })
                this.btnLoading = false

                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.paymentSubmit()
            } catch {
                this.btnLoading = false
                this.$message.error('操作失败，请重试')
            }
        },
        // 立即支付
        paymentSubmit () {
            this.centerPayDialogVisible = true
            this.$nextTick(() => {
                this.$refs.orderPayRef.getPayqrCodeUrl(this.parData)
            })
        },
        // 支付成功回调
        paySuccess (payStatus) {
            if (payStatus === 'PAY_SUCCESS') {
                this.$message.success('支付成功！')
                this.closePayDialogOkVisible()
            }
        },
        // 退出支付方式
        closePayDialogOkVisible () {
            this.centerPayDialogVisible = false
            this.$refs.orderPayRef.closeDialogVisible()
        }
    }
}
